<template>
  <div
    class="divider"
    :style="{
      borderTop: `${this.thickness || 1}px solid ${this.color || '#ddd'}`,
      margin: '0px 0',
      width: '100%',
    }"
  ></div>
</template>

<script>
export default {
  props: ['color', 'thickness'],
};
</script>
